/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AutomatedMessageData } from './automatedMessageData';

export interface VasServiceResonseModel { 
    id?: string;
    serviceId?: string;
    inCorrectMessage?: string;
    respondToInCorrectMessage?: boolean;
    keyword?: string;
    respondToAll?: boolean;
    autoResponseMessageToAll?: string;
    sendQuery?: boolean;
    sendTransactionlog?: boolean;
    queryUserName?: string;
    logUserName?: string;
    queryPassword?: string;
    logPassword?: string;
    queryApiKey?: string;
    logApiKey?: string;
    queryUrl?: string;
    logUrl?: string;
    automatedMessageData?: AutomatedMessageData;
    forwardIncorrectMessageToPartners?: boolean;
    tenantId?: string;
}